var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMineEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "14px",
    viewBox: "0 0 18 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_mine_email") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9996\\u9875",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u4E2A\\u4EBA\\u4E2D\\u5FC3-\\u6211\\u7684\\u4FE1\\u606F",
    transform: "translate(-1164, -343)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_mine_email",
    transform: "translate(1162, 339)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fillOpacity: 0,
    fill: "#D8D8D8",
    x: 0,
    y: 0,
    width: 22,
    height: 22
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-11",
    transform: "translate(2, 4)",
    fill: "#999999",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.35384615,14 C1.05385282,14 0,12.9687575 0,11.6966553 L0,2.30334469 C0,1.03081449 1.05341538,0 2.35384615,0 L15.6461538,0 C16.9465846,0 18,1.03081449 18,2.30334469 L18,11.6966553 C18,12.9687575 16.9461472,14 15.6461538,14 L2.35384615,14 Z M2.35384615,12.6450914 L15.6461538,12.6450914 C16.1814452,12.6450914 16.6153846,12.2204621 16.6153846,11.6966553 L16.6153846,2.30334469 C16.6153846,1.77953792 16.1814452,1.35490864 15.6461538,1.35490864 L2.35384615,1.35490864 C1.81855478,1.35490864 1.38461538,1.77953792 1.38461538,2.30334469 L1.38461538,11.6966553 C1.38461538,12.2212759 1.81883077,12.6450914 2.35384615,12.6450914 Z",
    id: "\\u5F62\\u72B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.942646154,4.35738619 C0.598836152,4.19335984 0.456008099,3.78765689 0.623630769,3.45122329 C0.791253439,3.11478969 1.20585154,2.97502599 1.54966154,3.13905234 L8.81833846,6.61087024 C8.93243077,6.66506658 9.06756923,6.66506658 9.18166154,6.61087024 L16.4503385,3.13905234 C16.6727445,3.0329459 16.9361045,3.05100606 17.1412131,3.18642974 C17.3463218,3.32185342 17.4620182,3.55406654 17.4447208,3.79559667 C17.4274234,4.03712679 17.2797599,4.25127975 17.0573538,4.35738619 L9.78978462,7.82812016 C9.29132308,8.06658408 8.70867692,8.06658408 8.21021538,7.82812016 L0.942646154,4.35738619 Z",
    id: "\\u8DEF\\u5F84"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMineEmail);
export default __webpack_public_path__ + "static/media/icon_mine_email.svg";
export { ForwardRef as ReactComponent };